export default {
    rotation: 0,
    arc: 0,
    translation: {
        x: 0,
        y: 0,
        manual: false,
        arc: false,
    },
};
